import { Instance, types } from 'mobx-state-tree';

export const BatchClassBatchSubjectConfiguration = types.model('BatchClassBatchSubjectConfigurationModel', {
  batchSubjectConfigurationId: types.string,
  count: types.number,
});

export type BatchClassBatchSubjectConfigurationModelType = Instance<typeof BatchClassBatchSubjectConfiguration>;
